export const ENTRIES = [
{
    name: "Megan Eggert",
    golfers: [
        "Rory McIlroy",
        "Will Zalatoris",
        "Cameron Smith",
        "Xander Schauffele",
        "Max Homa"
    ],
    tiebreaker: -12,
    },
{
    name: "Ray DelFava",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Sungjae Im",
        "Viktor Hovland",
    ],
    tiebreaker: -14
    },
{
    name: "Chris Donahue",
    golfers: [
        "Rory McIlroy",
        "Scottie Scheffler",
        "Collin Morikawa",
        "Xander Schauffele",
        "Patrick Cantlay"
    ],
    tiebreaker: -11
    },
{
    name: "George Eggert",
    golfers: [
        "Collin Morikawa",
        "Jason Day",
        "Xander Schauffele",
        "Justin Thomas",
        "Scottie Scheffler",
    ],
    tiebreaker: -9
    },
{
    name: "Rob Lantz",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Patrick Cantlay",
        "Collin Morikawa",
    ],
    tiebreaker: -8
    },
{
    name: "Al Shapiro",
    golfers: [
        "Patrick Cantlay",
        "Tony Finau",
        "Collin Morikawa",
        "Dustin Johnson",
        "Tommy Fleetwood"
    ],
    tiebreaker: -6
    },
{
    name: "Ron Fortman #1",
    golfers: [
        "Rory McIlroy",
        "Scottie Scheffler",
        "Patrick Cantlay",
        "Xander Schauffele",
        "Brooks Koepka",
    ],
    tiebreaker: -14
    },
{
    name: "Ernie Cervantes",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Tony Finau",
        "Hideki Matsuyama",
        "Max Homa",
    ],
    tiebreaker: -11
    },
{
    name: "E Kiz",
    golfers: [
        "Rory McIlroy",
        "Jon Rahm",
        "Scottie Scheffler",
        "Jordan Spieth",
        "Max Homa"
    ],
    tiebreaker: -13
    },
{
    name: "Julie Majeski",
    golfers: [
        "Cameron Young",
        "Rory McIlroy",
        "Jon Rahm",
        "Scottie Scheffler",
        "Jordan Spieth"
    ],
    tiebreaker: -8
    },
{
    name: "Matt Shapiro",
    golfers: [
        "Rory McIlroy",
        "Scottie Scheffler",
        "Xander Schauffele",
        "Hideki Matsuyama",
        "Tony Finau",
    ],
    tiebreaker: -6
    },
{
    name: "Karl Stevens #1",
    golfers: [
        "Scottie Scheffler",
        "Jordan Spieth",
        "Justin Thomas",
        "Jason Day",
        "Shane Lowry"
    ],
    tiebreaker: -16
    },
{
    name: "Kevin Donoghue #1",
    golfers: [
        "Rory McIlroy",
        "Collin Morikawa",
        "Scottie Scheffler",
        "Justin Thomas",
        "Cameron Smith"
    ],
    tiebreaker: -15
    },
{
    name: "Nick Morini #2",
    golfers: [
        "Justin Thomas",
        "Jordan Spieth",
        "Collin Morikawa",
        "Tony Finau",
        "Max Homa"
    ],
    tiebreaker: -13
    },
{
    name: "David Hess",
    golfers: [
        "Jon Rahm",
        "Rory McIlroy",
        "Patrick Cantlay",
        "Will Zalatoris",
        "Tony Finau"
    ],
    tiebreaker: -11
    },
{
    name: "Cam Majeski",
    golfers: [
        "Jordan Spieth",
        "Rory McIlroy",
        "Scottie Scheffler",
        "Collin Morikawa",
        "Sungjae Im"
    ],
    tiebreaker: -11
    },
{
    name: "Ian VanWazer",
    golfers: [
        "Justin Thomas",
        "Xander Schauffele",
        "Viktor Hovland",
        "Tony Finau",
        "Rory McIlroy"
    ],
    tiebreaker: -9
    },
{
    name: "Roger VanWazer",
    golfers: [
        "Scottie Scheffler",
        "Tom Kim",
        "Rory McIlroy",
        "Sungjae Im",
        "Xander Schauffele"
    ],
    tiebreaker: -9
    },
{
    name: "Connie Wade",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Jordan Spieth",
        "Xander Schauffele"
    ],
    tiebreaker: -10
    },
{
    name: "Brian Wade",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Tony Finau",
        "Jason Day",
        "Collin Morikawa"
    ],
    tiebreaker: -9
    },
{
    name: "Tom Arndt",
    golfers: [
        "Sam Burns",
        "Matthew Fitzpatrick",
        "Si Woo Kim",
        "Rory McIlroy",
        "Cameron Young"
    ],
    tiebreaker: -10
    },
{
    name: "Jay LaMar",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Cameron Smith",
        "Collin Morikawa",
        "Jordan Spieth"
    ],
    tiebreaker: -8
    },
{
    name: "Bob Chuchill",
    golfers: [
        "Rory McIlroy",
        "Max Homa",
        "Scottie Scheffler",
        "Brooks Koepka",
        "Jon Rahm"
    ],
    tiebreaker: -11
    },
{
    name: "Tony Fasuna",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Tony Finau",
        "Patrick Cantlay"
    ],
    tiebreaker: -9
    },
{
    name: "Mike Kiz",
    golfers: [
        "Jordan Spieth",
        "Rory McIlroy",
        "Tony Finau",
        "Jon Rahm",
        "Jason Day"
    ],
    tiebreaker: -13
    },
{
    name: "Pete Majeski",
    golfers: [
        "Xander Schauffele",
        "Jason Day",
        "Will Zalatoris",
        "Rory McIlroy",
        "Justin Thomas",
    ],
    tiebreaker: -16
    },
{
    name: "Forest Nelson",
    golfers: [
        "Rory McIlroy",
        "Jordan Spieth",
        "Scottie Scheffler",
        "Brooks Koepka",
        "Collin Morikawa"
    ],
    tiebreaker: -9
    },
{
    name: "Billy Pitcher",
    golfers: [
        "Scottie Scheffler",
        "Xander Schauffele",
        "Jordan Spieth",
        "Rory McIlroy",
        "Collin Morikawa"
    ],
    tiebreaker: -13
    },
{
    name: "Fortman #2",
    golfers: [
        "Rory McIlroy",
        "Scottie Scheffler",
        "Collin Morikawa",
        "Min Woo Lee",
        "Cameron Smith",
    ],
    tiebreaker: -14
    },
{
    name: "Nick Morini #1",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Xander Schauffele",
        "Sungjae Im",
    ],
    tiebreaker: -13
    },
{
    name: "Matt Majeski",
    golfers: [
        "Max Homa",
        "Tommy Fleetwood",
        "Rory McIlroy",
        "Will Zalatoris",
        "Sam Burns",
    ],
    tiebreaker: -11
    },
{
    name: "Carmardo",
    golfers: [
        "Scottie Scheffler",
        "Rory McIlroy",
        "Jon Rahm",
        "Patrick Cantlay",
        "Max Homa",
    ],
    tiebreaker: -10
    },
{
    name: "Gangham Majeski",
    golfers: [
        "Tom Kim",
        "Sungjae Im",
        "Hideki Matsuyama",
        "Kurt Kitayama",
        "Min Woo Lee",
    ],
    tiebreaker: -13
    },
]